import styled from 'styled-components';
import { themeGet, getMediaQuery, getPaletteColor, getTextColor } from '@magalu/stereo-ui-styles';
import Box from '@magalu/stereo-ui/atoms/Box';
import Button from '@magalu/stereo-ui/atoms/Button';
import Dialog from '@magalu/stereo-ui/atoms/Dialog';
import Flex from '@magalu/stereo-ui/atoms/Flex';
import Text from '@magalu/stereo-ui/atoms/Text';
export const Header = styled(Flex)`
  align-items: center;
  padding: 0 0 ${props => themeGet('space.2')(props)}px;

  ${getMediaQuery('large')} {
    padding: 0 0 ${props => themeGet('space.3')(props)}px;
  }
`;
export const ReviewerName = styled(Text).attrs(() => ({
  fontSize: 2
}))`
  color: ${props => themeGet('colors.darkSilver')(props)};
  font-weight: ${props => themeGet('fontWeights.regular')(props)};
  padding: ${props => themeGet('space.2')(props)}px;
  line-height: ${props => themeGet('lineHeights.plus')(props)}px;
`;
export const SubTitle = styled(Box).attrs(() => ({
  fontSize: 2
}))`
  color: ${getTextColor('davysGray')};
  font-weight: ${props => themeGet('fontWeights.regular')(props)};
  line-height: ${props => themeGet('lineHeights.plus')(props)}px;
`;
export const DateWrapper = styled(Box).attrs(() => ({
  fontSize: 2
}))`
  color: ${getTextColor('davysGray')};
  font-weight: ${props => themeGet('fontWeights.regular')(props)};
  line-height: ${props => themeGet('lineHeights.tall')(props)}px;
`;
export const Description = styled(Box).attrs(() => ({
  fontSize: 3
}))`
  color: ${themeGet('colors.black')};
  font-weight: ${themeGet('fontWeights.regular')};
  line-height: 24px;
  padding: ${themeGet('space.3')}px 0 ${themeGet('space.3')}px;
  word-break: break-word;
  width: 100%;
`;
export const ModalDetailsBody = styled.div`
  margin: 25px 0;
  display: flex;
  width: 100%;
  gap: 40px;
`;
export const SeeMore = styled(Box).attrs(() => ({
  color: 'primary.base',
  fontSize: 1
}))`
  display: inline;
  text-decoration: underline;
  cursor: pointer;
`;
export const ReviewWrapper = styled.span`
  width: 80px;
`;
export const CaroulselBlock = styled(Flex)`
  gap: 18px;
  width: 50%;
`;
export const ReviewContainer = styled(Box)`
  width: 50%;
`;
export const DialogStyled = styled(Dialog)`
  width: 720px;
  background-color: ${getPaletteColor('background.lighter')};
  padding: 20px;
  display: none;

  @media screen and (min-width: 500px) {
    display: block;
  }
`;
export const DialogContent = styled(Flex)`
  min-height: 400px;
`;
export const CondensedMediasBlock = styled(Box)`
  width: 100%;
`;
export const RotateButton = styled(Button)`
  width: 50%;
`;
export const RotateButtonBlock = styled(Flex)`
  width: 100%;
  height: 32px;
`;